<template>
    <a
        href="#"
        @click.prevent="setShowAddUserModal(true)"
        class="border-none shadow-none btn border-0 hover:bg-gray-200 mr-1"
        style="color: #03578b"
        role="button"
        id="hs-wallet-add-user"    >
        <svg class="w-4 h-4 opacity-50 flex-shrink-0" viewBox="0 0 16 16">
            <path
                fill="#fd421d"
                d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"
            />
        </svg>
        <span class="hidden xs:block ml-2">Add User</span>
    </a>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useWalletStore } from '@/store/wallet';

export default {
    name: 'AddWalletUserBtn',
    props: [],
    components: {},
    directives: {},
    data: () => ({
        errors: [],
    }),
    computed: {
        ...mapState(useWalletStore, ['showAddUserModal']),
    },
    methods: {
        ...mapActions(useWalletStore, ['setShowAddUserModal']),
    },
};
</script>
